import React, { useEffect } from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import { Table, Button, Container, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Message from '../components/Message'
import Loader from '../components/Loader'
import { listUsers, deleteUser } from '../actions/userActions'
import moment from 'moment'

// Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  faCheckCircle,
  faEdit,
  faTimesCircle,
  faTrashCan
} from '@fortawesome/free-regular-svg-icons'

const UserListScreen = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const userList = useSelector((state) => state.userList)
  const { loading, error, users } = userList

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  const userDelete = useSelector((state) => state.userDelete)
  const { successdelete } = userDelete

  const formatDate = (date) => {
    return moment(date).format('MM/DD/YYYY HH:mm')
  }

  const deleteHandler = (id) => {
    if (window.confirm('Are you sure')) {
      dispatch(deleteUser(id))
    }
  }

  // Graceful logout if data is not available
  useEffect(() => {
    if (
      !userInfo ||
      userInfo.isAdmin === undefined ||
      userInfo.isOwner === undefined ||
      (!userInfo.isAdmin && !userInfo.isOwner)
    ) {
      dispatch({ type: 'USER_LIST_RESET' })
      navigate('/login')
    }
  }, [userInfo, navigate, dispatch])

  useEffect(() => {
    if (
      !userInfo ||
      userInfo.isAdmin === undefined ||
      userInfo.isOwner === undefined
    ) {
      dispatch({ type: 'USER_LIST_RESET' })
      navigate('/login')
    }
  }, [userInfo, navigate, dispatch])

  // Page load
  useEffect(() => {
    if (
      userInfo &&
      (userInfo.isAdmin || userInfo.isOwner) &&
      userInfo.isAdmin !== undefined &&
      userInfo.isOwner !== undefined
    ) {
      dispatch(listUsers())
    } else {
      dispatch({ type: 'USER_LIST_RESET' })
      navigate('/login')
    }
  }, [dispatch, navigate, userInfo, successdelete])

  return (
    <Container>
      <Row>
        <Col>
          <h3 className='my-2'>Users</h3>
        </Col>
        <Col className='text-right'>
          <Button
            className='my-2'
            size='sm'
            onClick={() => navigate('/admin/user/register')}
          >
            Create User
          </Button>
        </Col>
      </Row>

      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <Table striped bordered hover responsive className='table-sm'>
          <thead>
            <tr>
              <th>ID</th>
              <th>LAST</th>
              {/* {userInfo.isOwner && <th>CID</th>} */}
              <th>NAME</th>
              <th>EMAIL</th>
              <th>ADMIN</th>
              <th>DISABL</th>
              {/* {userInfo.isOwner && <th>OWNER</th>} */}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user._id}>
                <td>{user._id}</td>
                <td>{formatDate(user.lastLogin)}</td>
                {/* {userInfo.isOwner && <td>{user.cid}</td>} */}
                <td>{user.name}</td>
                <td>
                  <a href={`mailto:${user.email}`}>{user.email}</a>
                </td>
                <td>
                  {user.isAdmin ? (
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      style={{ color: 'green' }}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      style={{ color: 'red' }}
                    />
                  )}
                </td>
                <td>
                  {user.isDisabled ? (
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      style={{ color: 'green' }}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      style={{ color: 'red' }}
                    />
                  )}
                </td>

                <td>
                  <LinkContainer to={`/admin/user/${user._id}`}>
                    <Button variant='primary' className='btn-sm'>
                      <FontAwesomeIcon icon={faEdit} />
                    </Button>
                  </LinkContainer>
                </td>
                <td>
                  <Button
                    variant='danger'
                    className='btn-sm'
                    onClick={() => deleteHandler(user._id)}
                  >
                    <FontAwesomeIcon icon={faTrashCan} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  )
}

export default UserListScreen
